import { RadioButton } from 'components/Shared/Form';
import { PartPaymentItem } from 'models/PartPaymentItem';
import { useEffect } from 'react';
import { WrappedFieldInputProps } from 'redux-form';
import styles from './partPayment.scss';
import { rm } from 'utils';
import classNames from 'classnames';

interface PartPaymentProps {
  items: PartPaymentItem[];
  input: WrappedFieldInputProps;
  reset: () => void;
  dispatchGtmChangePaymentMethod: (newPaymentMethod: string) => void;
  paymentMethod: string;
}
export const PartPayment = ({
  items,
  input,
  reset,
  dispatchGtmChangePaymentMethod,
  paymentMethod
}: PartPaymentProps) => {
  const { value, onChange } = input;
  // Reset part payment selection on unmount
  useEffect(() => reset, [reset]);

  const getPartPaymentInfoText = () => {
    const selected = value ? items.find(p => p.id === +value) : undefined;

    return selected
      ? rm(
          'checkout_partpayment_interest_rd3',
          selected.interest,
          selected.startFeeText,
          selected.monthFeeText
        )
      : '';
  };

  const handleOnChange = (newValue: string) => {
    const paymentMethodAndMonths = `${paymentMethod}: ${newValue}`;
    dispatchGtmChangePaymentMethod(paymentMethodAndMonths);
    onChange(newValue);
  };

  const partPaymentInfoText = getPartPaymentInfoText();
  return (
    <>
      <ul className={styles.partPayments}>
        {items.map(
          ({ id, costPerMonthText, specialPartPaymentString, months, isCampaign, interest }) => {
            const selected = Boolean(value && +value === id);
            return (
              <li
                key={id}
                className={classNames(styles.partPayment, {
                  [styles.fullWidthPartPaymentOption]: isCampaign
                })}
              >
                <RadioButton
                  {...input}
                  size="small"
                  value={id}
                  radioButtonClassName={styles.partPaymentRadioButton}
                  checked={selected}
                  onChange={handleOnChange}
                  label={
                    <Label
                      costPerMonthText={costPerMonthText}
                      isCampaign={isCampaign}
                      months={months}
                      specialPartPaymentString={specialPartPaymentString}
                      interest={interest}
                    />
                  }
                />
              </li>
            );
          }
        )}
      </ul>

      {partPaymentInfoText && (
        <div className={styles.campaignDescription}>{partPaymentInfoText}</div>
      )}
    </>
  );
};

type LabelProps = Pick<
  PartPaymentProps['items'][number],
  'isCampaign' | 'months' | 'specialPartPaymentString' | 'costPerMonthText' | 'interest'
>;

const Label = ({
  isCampaign,
  months,
  specialPartPaymentString,
  costPerMonthText,
  interest
}: LabelProps) => {
  if (isCampaign) {
    return (
      <span className={styles.months}>
        {specialPartPaymentString}
        <FreeFromInterest interest={interest} />
      </span>
    );
  }

  return (
    <>
      <span className={styles.months}>{rm('checkout_partpayment_months', months)}</span>
      <FreeFromInterest interest={interest} />
      <span className={styles.monthPrice}>
        {rm('checkout_partpayment_monthprice', costPerMonthText, '')}
      </span>
    </>
  );
};

type FreeFromInterestProps = Pick<PartPaymentProps['items'][number], 'interest'>;
const FreeFromInterest = ({ interest }: FreeFromInterestProps) => {
  if (interest) return null;
  return <span className={styles.monthPrice}>{rm('checkout_no_interest')}</span>;
};
